export const siteSettings = {
  name: "Fantassia Markets",
  link: "https://fantassiamarkets.net",
  email: "support@fantassiamarkets.net",
  appLink: "https://app.fantassiamarkets.net",
};
